export const recruitmentJobsPipelineArticle = {
  title: 'Recruitment Portal: Jobs & Pipeline',
  slug: 'recruitment-jobs-pipeline',
  content: `Recruitment Portal: Jobs & Pipeline

Create jobs and manage candidates through stages.

1) Post a job
- Click Post Job in the header.
- Fill out the job form and save.

2) Manage job status
- Edit jobs to update status or details.

3) Pipeline board
- Use the Pipeline tab to move candidates between stages.

4) Refresh data
- Use Refresh to reload jobs and applications.
`,
};
